import React, { useEffect } from "react";
import { Form } from "antd";
import moment from "moment";
import BlockingTypesAdmin from "../../components/BlockingTypesAdmin/BlockingTypesAdmin";
import { fetchBlockingTypes } from "../../store/slices/blocking";
import { useAppDispatch } from "../..";
import { toHttpFormatStartOfDay } from "../../lib/utils/formatDate";

function BlockingTypesContainer() {
  const dispatch = useAppDispatch();

  const [form] = Form.useForm();

  // Первоначальный запрос данных таблицы
  useEffect(() => {
    dispatch(fetchBlockingTypes({ onDate: toHttpFormatStartOfDay(moment().startOf("day")) }));
  }, []);

  const handleSearch = (values) => {
    dispatch(fetchBlockingTypes({ onDate: toHttpFormatStartOfDay(values.onDate) }));
  };

  return (
    <div className="container_height">
      <BlockingTypesAdmin form={form} handleSearch={handleSearch} />
    </div>
  );
}

export default BlockingTypesContainer;
